module.exports = __webpack_public_path__ + "files/09a43244b168ebf9f73cb3fd3bafef13.svg";